import {
  Backdrop,
  Button,
  ChartNew,
  DevNote,
  FormFieldSet,
  InfoCardNewAdv,
  InfoTimeCardAdv,
  InfoWrapper,
  LogoLoader,
  Modal,
  ProgressBar,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../components";

import { useEffect, useLayoutEffect, useState } from "react";
import { formatCurrency } from "../../../../utils/stringUtils";
import { getDashboardData } from "../../../../utils/dashboard";
import dayjs from "dayjs";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentInvoiceStart } from "../../../../redux/slices/invoices/invoicesSlice";
import InvoiceDetails from "./InvoiceDetails";
import { usePagination } from "../../../../hooks";
import { getTotalCountApi } from "../../../../redux/slices/totalCount/totalCountApi";
import { reportPeriodOptions } from "../../../../assets/data/enumData";
import { dateFormator, mapTableRows } from "../../../../utils";
import { fetchAllInvoices } from "../../../../redux/slices/invoices/invoicesApi";
import { InvoiceKPICard } from "../../Dashboard/Modals/KpiViewModal";

const DropdownOptions = [
  { label: "ALL", value: "all" },
  { label: "IT", value: 3 },
  { label: "NON-IT", value: 2 },
  { label: "W2", value: 1 },
];

const revenueFlowData = [
  { label: "Jan", month: 1, value: 0, invoices: 0, revenue: 0 },
  { label: "Feb", month: 2, value: 0, invoices: 0, revenue: 0 },
  { label: "Mar", month: 3, value: 0, invoices: 0, revenue: 0 },
  { label: "Apr", month: 4, value: 0, invoices: 0, revenue: 0 },
  { label: "May", month: 5, value: 0, invoices: 0, revenue: 0 },
  { label: "Jun", month: 6, value: 0, invoices: 0, revenue: 0 },
  { label: "Jul", month: 7, value: 0, invoices: 0, revenue: 0 },
  { label: "Aug", month: 8, value: 0, invoices: 0, revenue: 0 },
  { label: "Sep", month: 9, value: 0, invoices: 0, revenue: 0 },
  { label: "Oct", month: 10, value: 0, invoices: 0, revenue: 0 },
  { label: "Nov", month: 11, value: 0, invoices: 0, revenue: 0 },
  { label: "Dec", month: 12, value: 0, invoices: 0, revenue: 0 },
];

export const fetchInvoiceDashboardCards = async (from = null, to = null) => {
  try {
    if (!from || !to) return;
    const dashboard = await getDashboardData(
      {
        invoiceDashboard: {
          type: "AG_STATS",
          value: [
            true,
            dayjs(from).format("YYYY-MM-DD"),
            dayjs(to).format("YYYY-MM-DD"),
          ],
        },
      },
      "Invoice",
    );
    let cardsResponse = dashboard?.[0] || {};
    const cardsData = [
      {
        title: "All Invoices",
        value: formatCurrency(cardsResponse?.allInvoice),
      },
      {
        title: "Open Invoices",
        value: formatCurrency(cardsResponse?.openInvoice),
      },
      {
        title: "Due Invoices",
        value: formatCurrency(cardsResponse?.dueInvoice),
      },
      {
        title: "Paid Invoices",
        value: formatCurrency(cardsResponse?.paidInvoice),
      },
    ];
    return cardsData || [];
  } catch (error) {
    console.error("Error in fetching dashboard cards", error);
  }
};

export const fetchInvoicesDashboard = async (
  limit,
  page,
  invoicePreviewCallback = null,
) => {
  try {
    const payload = {
      coll: "Invoice",
      lim: limit,
      pg: page,
      ref: "Client Employee",
      incl: ["businessName uiid roleContacts", "firstName lastName"],
      ret: "uiid dueDate invoiceNum invoiceDate clientId employeeId amounts ",
      fil: JSON.stringify({
        "version.isLatest": {
          type: "NONE",
          value: true,
        },
        dueDate: {
          type: "LT",
          value: new Date(),
        },
        "amounts.due": { type: "EXCLUDE", value: 0 },
      }),
      sort: JSON.stringify({ dueDate: 1 }),
    };
    const totalPayload = {
      collection: "invoices",
      coll: "Invoice",
      filters: {
        "version.isLatest": {
          type: "NONE",
          value: true,
        },
        dueDate: {
          type: "LT",
          value: new Date(),
        },
        "amounts.due": { type: "EXCLUDE", value: 0 },
      },
    };
    const [invoices, total] = await Promise.allSettled([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.INVOICES.GET_ALL,
        params: payload,
      }),
      getTotalCountApi(totalPayload),
    ]);
    // setTotalCounts((prev) => ({
    //   ...prev,
    //   ag1: total?.value?.data?.data || 0,
    // }));
    const invoicesOverDue = invoices?.value?.data?.data || [];
    // const mappedInvoices = invoicesOverDue.map((i) => ({
    //   // invoiceNumber: i.invoiceNum,
    //   // clientName: i?.clientId?.businessName || "",
    //   // candidateName:
    //   //   i?.employeeId?.firstName + " " + i?.employeeId?.lastName || "",
    //   // invoiceAmount: formatCurrency(i?.amounts?.invoiced),
    //   // invoiceDate: dayjs(i.invoiceDate).format("MM/DD/YYYY"),
    //   "Invoice Number": (
    //     <div
    //       className="flex items-center gap-1"
    //       onClick={() => {
    //         if (invoicePreviewCallback) {
    //           invoicePreviewCallback(i.uiid);
    //         }
    //       }}
    //       key={i.uiid}
    //     >
    //       <span className="cursor-pointer text-linkblue">{i.invoiceNum}</span>
    //     </div>
    //   ),
    //   // "Invoice Number": i.invoiceNum,
    //   "Client Name": i?.clientId?.businessName || "",
    //   "Candidate Name":
    //     i?.employeeId?.firstName + " " + i?.employeeId?.lastName || "",
    //   "Invoice Amount": i?.amounts?.invoiced,
    //   "Invoice Date": dayjs(i.invoiceDate).format("MM/DD/YYYY"),
    //   id: i.uiid,
    //   roleContacts: i?.clientId?.roleContacts || [],
    // }));
    const mappedInvoices = invoicesOverDue.map((i) => ({
      "Invoice Number": (
        <SmartTooltip
          description={i?.invoiceNum}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal
        >
          <div
            className="flex items-center gap-1"
            onClick={() => {
              if (invoicePreviewCallback) {
                invoicePreviewCallback(i.uiid);
              }
            }}
            key={i.uiid}
          >
            <span className="cursor-pointer text-linkblue line-clamp-1">
              {i.invoiceNum}
            </span>
          </div>
        </SmartTooltip>
      ),
      "Client Name": (
        <SmartTooltip
          description={i?.clientId?.businessName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal
        >
          <span className="line-clamp-1">
            {i?.clientId?.businessName || ""}
          </span>
        </SmartTooltip>
      ),
      "Candidate Name": (
        <SmartTooltip
          description={`${i?.employeeId?.firstName} ${i?.employeeId?.lastName}`}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal
        >
          <span className="line-clamp-1">
            {`${i?.employeeId?.firstName} ${i?.employeeId?.lastName}` || ""}
          </span>
        </SmartTooltip>
      ),
      "Invoice Amount": i?.amounts?.invoiced,
      "Invoice Date": dayjs(i.invoiceDate).format("MM/DD/YYYY"),
      id: i.uiid,
      roleContacts: i?.clientId?.roleContacts || [],
    }));
    return {
      mappedInvoices: mappedInvoices,
      ag1Total: total?.value?.data?.data || 0,
    };
  } catch (error) {
    console.error("Error in fetchInvoicesDashboard:", error);
  }
};

export const fetchInvoicesAgingReport = async (from, to, limit, page) => {
  // if (!dates.ag2.from) return;
  try {
    const datesPayload = {
      from: from ? dayjs(from).format("YYYY-MM-DD") : null,
      to: to ? dayjs(to).format("YYYY-MM-DD") : null,
    };
    const dashboard = await getDashboardData(
      {
        clientPendingPay: {
          type: "AG_LOOKUP_DATA",
          value: [true, datesPayload.from, datesPayload.to],
        },
      },
      "Invoice",
      limit,
      page,
    );
    let fetchedAgingReports = Array.isArray(dashboard) ? dashboard : [];
    const mappedFetchedAgingReports =
      fetchedAgingReports?.[0]?.data?.map((i) => ({
        "Client Name": i?.businessName || "",
        Current: i?.current ? formatCurrency(i?.current) : "-",
        "1-30": i?.upto30 ? formatCurrency(i?.upto30) : "-",
        "30-60": i?.upto60 ? formatCurrency(i?.upto60) : "-",
        "60-90": i?.upto90 ? formatCurrency(i?.upto90) : "-",
        "90+": i?.over90 ? formatCurrency(i?.over90) : "-",
        // Current: i?.current,
        // "1-30": i?.upto30,
        // "30-60": i?.upto60,
        // "60-90": i?.upto90,
        // "90+": i?.over90,
      })) || [];
    // setTotalCounts((prev) => ({
    //   ...prev,
    //   ag2: fetchedAgingReports?.[0]?.count?.[0]?.total || 0,
    // }));
    return {
      agingReport: mappedFetchedAgingReports,
      ag2Total: fetchedAgingReports?.[0]?.count?.[0]?.total || 0,
    };
  } catch (error) {
    console.error("Error in fetching aging reports", error);
  } finally {
  }
};

export const fetchInvoicesInfoGraphicBar = async () => {
  try {
    const dashboard = await getDashboardData(
      {
        allClientPendingPay: {
          type: "AG_LOOKUP_DATA",
          value: [true],
        },
      },
      "Invoice",
    );
    let fetchedInfoGraphicBar = Array.isArray(dashboard) ? dashboard : [];
    return fetchedInfoGraphicBar[0];
  } catch (error) {
    console.error("Error in fetching aging reports", error);
  }
};

export const fetchRevenueFlow = async (revenueType, year) => {
  try {
    if (revenueType === "all") {
      revenueType = null;
    }
    const response = await getDashboardData(
      {
        revenueByYear: {
          type: "AG_STATS",
          // second params is year// third param when we have dropdown-filter available-employementType
          // value: [true, new Date().getFullYear(), revenueType],
          value: [true, year, revenueType],
        },
      },
      "Invoice",
    );
    const data = revenueFlowData.map((list) => {
      let monthData = Array.isArray(response)
        ? response?.find((d) => d.month === list.month) || {}
        : {};
      return {
        ...list,
        value: monthData?.revenue ? Number(monthData?.revenue).toFixed(2) : 0,
        invoices: monthData?.invoices
          ? Number(monthData?.invoices).toFixed(2)
          : 0,
        revenue: monthData?.revenue ? Number(monthData?.revenue).toFixed(2) : 0,
      };
    });
    return data || revenueFlowData;
  } catch (error) {
    console.error("Error in fetching revenue flow", error);
  }
};

const InvoiceDashboard = () => {
  const dispatch = useDispatch();
  const [revenueFlowModalOpen, setRevenueFlowModalOpen] = useState(false);
  console.log("Rendering Invoice Dashboard  ", revenueFlowModalOpen);
  const { loading, error: InvoiceModalError } = useSelector(
    (state) => state.invoices,
  );
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i,
  );
  const [selectedYear, setSelectedYear] = useState(years[0]);
  const yearOptions = years.map((year) => ({
    label: year.toString(),
    value: year,
  }));
  const [modalData, setModalData] = useState(null);
  const [phoneModal, setPhoneModal] = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [kpiModalOpen, setKpiModalOpen] = useState(false);
  const [kpiModalType, setKpiModalType] = useState(null);
  console.log("Selected KPI Modal Type: ", kpiModalType);
  const [selectedOption, setSelectedOption] = useState(
    DropdownOptions[0].value,
  );
  const [reportPeriod, setReportPeriod] = useState(
    reportPeriodOptions[0].value,
  );
  const handleRevenueSelectChange = async (value) => {
    const revenueFlow = await fetchRevenueFlow(value, selectedYear);
    setData((prev) => ({ ...prev, revenueFlow }));
    setSelectedOption(value);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [totalCounts, setTotalCounts] = useState({
    ag1: 0,
    ag2: 0,
  });
  const [data, setData] = useState({
    cardsData: [
      {
        title: "All Invoices",
        value: formatCurrency(0),
      },
      {
        title: "Open Invoices",
        value: formatCurrency(0),
      },
      {
        title: "Due Invoices",
        value: formatCurrency(0),
      },
      {
        title: "Paid Invoices",
        value: formatCurrency(0),
      },
    ],
    invoices: [],
    agingReport: [],
    infographicBar: {},
    revenueFlow: revenueFlowData,
  });

  console.log({ data });

  const [dates, setDates] = useState({
    cards: {
      from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    },
    ag2: {
      from: null,
      to: null,
    },
  });
  console.log({ dates });

  const handleClickForInvoice = (invoiceId) => {
    if (!invoiceId)
      return showToast(
        "Something went wrong while previewing invoice",
        "error",
        3000,
      );
    dispatch(
      getCurrentInvoiceStart({
        filters: { uiid: { type: "NONE", value: invoiceId } },
        coll: "Invoice",
        ref: "Client Employee Placement Timesheet",
        incl: ["", "firstName lastName", "", "attachments"],
      }),
    );
    setSelectedInvoice(invoiceId);
  };

  const {
    page: ag1Page,
    limit: ag1Limit,
    setPage: ag1SetPage,
    handleLimitChange: ag1HandleLimitChange,
  } = usePagination(5);
  const {
    page: ag2Page,
    limit: ag2Limit,
    setPage: ag2SetPage,
    handleLimitChange: ag2HandleLimitChange,
  } = usePagination(5);
  //for datepickerrange
  // const handleDateRangeCards = (key, value) => {
  //   setDates((prevState) => ({ ...prevState, [key]: value }));
  // };
  //for monthpicker
  const handleDateRangeCards = (key, value) => {
    if (!value) return;

    const startOfMonth = new Date(value.getFullYear(), value.getMonth(), 1);
    const endOfMonth = new Date(value.getFullYear(), value.getMonth() + 1, 0);

    setDates((prevState) => ({
      ...prevState,
      [key]: {
        from: startOfMonth,
        to: endOfMonth,
      },
    }));
  };
  const handleCall = (number) => {
    const deepLink = `zoomphonecall:${encodeURIComponent(number)}`;
    window.location.href = deepLink;
  };

  const handleDashboardCalls = async () => {
    const startTime = performance.now();
    try {
      if (!dates.cards.from || !dates.cards.to) return;
      setIsLoading(true);
      // const [dashboardCards, invoices, agingReport, revenueFlow] =
      const [dashboardCards, invoices, infoGraphicBar, revenueFlow] =
        await Promise.allSettled([
          fetchInvoiceDashboardCards(dates.cards.from, dates.cards.to),
          fetchInvoicesDashboard(ag1Limit, ag1Page, handleClickForInvoice),
          // fetchInvoicesAgingReport(),
          fetchInvoicesInfoGraphicBar(),
          fetchRevenueFlow(selectedOption, selectedYear),
        ]);
      // setData({
      //   cardsData: dashboardCards?.value || [],
      //   invoices: invoices?.value || [],
      //   agingReport: agingReport?.value?.agingReport || [],
      //   infographicBar: agingReport?.value?.infographicBar || [],
      //   revenueFlow: revenueFlow?.value || [],
      // });
      setData((prev) => ({
        ...prev,
        cardsData: dashboardCards?.value || [],
        invoices: invoices?.value?.mappedInvoices || [],
        // agingReport: agingReport?.value?.agingReport || [],
        infographicBar: infoGraphicBar?.value || {},
        revenueFlow: revenueFlow?.value || [],
      }));
      setTotalCounts((prev) => ({
        ...prev,
        ag1: invoices?.value?.ag1Total || 0,
      }));
      const endTime = performance.now();
      console.assert(
        import.meta.env.VITE_APP_ENV !== "local",
        `Time complexity: ${Number(endTime - startTime).toFixed(2)}ms`,
      );
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useLayoutEffect(() => {
    handleDashboardCalls();
    // }, [dates, ag1Page, ag2Page, ag1Limit, ag2Limit]);
  }, [dates?.cards?.from, dates?.cards?.to, ag1Page, ag1Limit]);
  const fetchAgingData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchInvoicesAgingReport(
        dates.ag2.from,
        dates.ag2.to,
        ag2Limit,
        ag2Page,
      );
      setData((prev) => ({
        ...prev,
        agingReport: data?.agingReport,
      }));
      setTotalCounts((prev) => ({
        ...prev,
        ag2: data?.ag2Total || 0,
      }));
    } catch (error) {
      console.error("Error in fetchAgingData:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchAgingData();
  }, [ag2Page, ag2Limit]);

  const addActions = (values) => {
    return values.map((value) => ({
      ...value,
      Actions: (
        <div className="flex gap-2 items-center">
          <Button
            type="icon"
            icon={"call"}
            color="black"
            variant="text"
            onClick={() => {
              setPhoneModal(true);
              setModalData(value.roleContacts);
            }}
          />
          <Button
            type="icon"
            icon={"mail"}
            color="black"
            variant="text"
            onClick={() => {
              setEmailModal(true);
              setModalData(value.roleContacts);
            }}
          />
        </div>
      ),
    }));
  };

  const renderInfoBarExpandContent = () => (
    <div className="grid grid-cols-4 gap-5 mx-15 py-4">
      <div className="flex flex-col bg-success-50 border border-success rounded-xl p-4 ">
        <span className="text-success-700 text-2xl font-semibold">
          {formatCurrency(
            Object.values(data?.infographicBar).reduce((a, b) => a + b, 0),
          )}
        </span>
        <p className="py-2">Total Revenue</p>
        <span className="text-success text-sm">100% of Data</span>
      </div>

      <div className="flex flex-col bg-info-50 border border-info rounded-xl p-4 ">
        {/* //take the peak vcalue from infographic bar object */}
        <span className="text-info-700 text-2xl font-semibold">
          {formatCurrency(Math.max(...Object.values(data?.infographicBar)))}
        </span>
        <p className="py-2">Peak Value</p>
        <span className="text-info text-sm">Best Period</span>
      </div>

      <div className="flex flex-col bg-leave-50 border border-leave rounded-xl p-4 ">
        <span className="text-leave-700 text-2xl font-semibold">
          {Object.keys(data?.infographicBar)?.length > 0
            ? formatCurrency(
                Object.values(data?.infographicBar)?.reduce(
                  (a, b) => (a || 0) + (b || 0),
                  0,
                ) / 5,
              )
            : 0}
        </span>
        <p className="py-2">Average</p>
        <span className="text-leave text-sm">Per Period</span>
      </div>

      <div className="flex flex-col bg-warning-50 border border-warning rounded-xl p-4 ">
        <span className="text-warning-700 text-2xl font-semibold">
          {Object.keys(data?.infographicBar)?.length - 1
            ? Object.keys(data?.infographicBar)?.length - 1
            : 0}
        </span>
        <p className="py-2">Time Periods</p>
        <span className="text-warning text-sm">Data Points</span>
      </div>
    </div>
  );

  const renderRevenueExpandContent = () => {
    const formatVal = (val) =>
      Number(val).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    return (
      <div className="flex flex-col flex-1 gap-8 mx-10 py-4">
        <div className="grid grid-cols-6 gap-7 mx-2">
          {data?.revenueFlow?.map((rev) => (
            <div className="flex flex-col items-center px-5 py-3 rounded-xl border-2 border-gray-200 shadow-md">
              <span className="text-primary">{rev?.label}</span>
              <ProgressBar
                value={Number(rev?.revenue) || 0}
                maxValue={data?.revenueFlow?.reduce(
                  (acc, curr) => acc + Number(curr.revenue || 0),
                  0,
                )}
                height="h-2"
                width="w-20"
                className={"my-2"}
              />
              <span className="text-xlfont-semibold">
                {formatCurrency(Number(rev.revenue))}
              </span>
              <span
                className={`text-sm text-info mt-1 ${rev?.revenue ? "cursor-pointer" : ""}`}
                onClick={() => {
                  setRevenueFlowModalOpen(rev?.revenue);
                  console.log("Revenue Modal Opened for ", rev);
                  setKpiModalType(rev?.month || null);
                }}
              >
                {Number(rev?.invoices || 0).toFixed(0)}
              </span>
            </div>
          )) || []}
        </div>

        <div className="grid grid-cols-4 gap-5">
          <div className="flex flex-col bg-success-50 border border-success rounded-xl p-4 ">
            <span className="text-success-700 text-2xl font-semibold">
              {formatCurrency(
                data?.revenueFlow?.reduce(
                  (acc, curr) => acc + Number(curr.revenue || 0),
                  0,
                ),
              )}
            </span>
            <p className="py-2">Total Revenues</p>
            <span className="text-success text-sm">12 Months</span>
          </div>

          <div className="flex flex-col bg-info-50 border border-info rounded-xl p-4 ">
            <span className="text-info-700 text-2xl font-semibold">
              {formatVal(
                data?.revenueFlow?.reduce(
                  (acc, curr) => acc + Number(curr.invoices || 0),
                  0,
                ),
              )}
            </span>
            <p className="py-2">Total Invoices</p>
            <span className="text-info text-sm">All Periods</span>
          </div>

          <div className="flex flex-col bg-leave-50 border border-leave rounded-xl p-4 ">
            <span className="text-leave-700 text-2xl font-semibold">
              {formatCurrency(
                data?.revenueFlow?.reduce(
                  (acc, curr) => acc + Number(curr.revenue || 0),
                  0,
                ) / 12 || 0,
              )}
            </span>
            <p className="py-2">Average Monthly</p>
            <span className="text-leave text-sm">Revenue</span>
          </div>

          <div className="flex flex-col bg-warning-50 border border-warning rounded-xl p-4 ">
            <span className="text-warning-700 text-2xl font-semibold">
              {formatVal(
                data?.revenueFlow?.reduce(
                  (acc, curr) => acc + Number(curr.invoices || 0),
                  0,
                ) / 12 || 0,
              )}
            </span>
            <p className="py-2">Average Invoices</p>
            <span className="text-warning text-sm">Per Month</span>
          </div>
        </div>
      </div>
    );
  };

  const renderAging1Content = () => (
    <h5 className="text-center text-2xl font-[600] mb-2">
      Aging Summary Report
    </h5>
  );

  const getDateRangeFromPeriod = (periodValue) => {
    const today = new Date();
    const currentYear = today.getFullYear();

    switch (periodValue) {
      case 1:
        return { from: null, to: null };

      case 2:
        return { from: null, to: null };

      case 3:
        return { from: today, to: today };

      case 4:
        const dayOfWeek = today.getDay();
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - dayOfWeek);
        return { from: startOfWeek, to: today };

      case 5:
        const startOfMonth = new Date(currentYear, today.getMonth(), 1);
        return { from: startOfMonth, to: today };

      case 6:
        return {
          from: new Date(currentYear, 0, 1),
          to: new Date(currentYear, 2, 31),
        };

      case 7:
        return {
          from: new Date(currentYear, 3, 1),
          to: new Date(currentYear, 5, 30),
        };

      case 8:
        return {
          from: new Date(currentYear, 6, 1),
          to: new Date(currentYear, 8, 30),
        };

      case 9:
        return {
          from: new Date(currentYear, 9, 1),
          to: new Date(currentYear, 11, 31),
        };

      case 10:
        const lastYear = currentYear - 1;
        return {
          from: new Date(lastYear, 0, 1),
          to: new Date(lastYear, 11, 31),
        };

      default:
        return { from: null, to: null };
    }
  };

  const handleReportPeriodChange = (value) => {
    setReportPeriod(value);
    const dateRange = getDateRangeFromPeriod(value);
    setDates((prevState) => ({
      ...prevState,
      ag2: dateRange,
    }));
  };

  const renderAging2Content = () => (
    <div className="flex flex-col gap-x-4">
      {/* <h5 className="text-center text-2xl font-[600] mb-2">
        Aging Summary Report
      </h5> */}
      <p className="text-center font-[500]">
        {dates.ag2.from
          ? `As of ${dayjs(dates.ag2.from).format("MMMM DD")}`
          : "\u00A0"}{" "}
        {dates.ag2.from && dates.ag2.to
          ? `- ${dayjs(dates.ag2.to).format("MMMM DD")}`
          : ""}
      </p>
      <div className="flex items-end gap-4 my-3">
        <div className="w-[180px]">
          <FormFieldSet
            title="Report Period"
            type="select"
            placeholder="Select"
            value={reportPeriod || ""}
            onChange={handleReportPeriodChange}
            options={reportPeriodOptions}
          />
        </div>
        {reportPeriod !== 1 && (
          <>
            <FormFieldSet
              title="From"
              type="datepicker"
              placeholder="Select Start Date"
              value={dates?.ag2?.from}
              showDropdown={false}
              onChange={(value) =>
                setDates((prevState) => ({
                  ...prevState,
                  ag2: { ...prevState.ag2, from: value },
                }))
              }
            />
            <FormFieldSet
              title="To"
              type="datepicker"
              placeholder="Select End Date"
              value={dates?.ag2?.to}
              showDropdown={false}
              onChange={(value) =>
                setDates((prevState) => ({
                  ...prevState,
                  ag2: { ...prevState.ag2, to: value },
                }))
              }
            />
          </>
        )}
        <Button title={"Apply"} onClick={() => fetchAgingData()} />
        {/* <DevNote>
          <div>
          <div>
          Current::::{data?.infographicBar?.reduce((a, b) => a + (b?.current || 0), 0)}
          </div>
          <div>
          Current::::{data?.infographicBar?.reduce((a, b) => a + (b?.current || 0), 0)}
          </div>
          <div>
          Current::::{data?.infographicBar?.reduce((a, b) => a + (b?.current || 0), 0)}
          </div>
          </div>
        </DevNote> */}
      </div>
    </div>
  );
  if (kpiModalOpen) {
    return (
      <InvoiceKPICard
        onClose={() => {
          setKpiModalOpen(false);
          setKpiModalType(null);
        }}
        cardsDuration={dates?.cards}
        dataType={kpiModalType}
      />
    );
  }

  return (
    <div className="px-1 py-2 flex flex-col gap-4">
      <>
        {import.meta.env.VITE_APP_ENV === "local" && (
          <div className="flex items-center justify-end col-span-2 w-max-[50px]">
            <Button
              onClick={() => {
                console.groupCollapsed("--- New Log Session ---");
                console.groupEnd();
                handleDashboardCalls();
              }}
              variant="outlined"
              icon="autorenew"
              title={"Refresh"}
            />
          </div>
        )}
      </>
      <div className="bg-[#FAFCFF] col-span-2 flex flex-col px-3 py-4 border border-gray-200 rounded-2xl shadow-lg">
        <div className="flex justify-between items-center mb-4">
          <h5>Invoice Dashboard Overview</h5>
          <div className="w-full max-w-[200px]">
            <FormFieldSet
              noTitle
              placeholder="Select date range"
              type="monthpicker"
              // value={{
              //   from: dates?.cards?.from || null,
              //   to: dates?.cards?.to || null,
              // }}
              value={dates?.cards?.from || null}
              onChange={(value) => handleDateRangeCards("cards", value)}
              showDropdown={false}
            />
          </div>
        </div>

        {/* <div className="grid grid-cols-4 gap-8 mt-4"> */}
        {/* <InfoWrapper>
          {data?.cardsData?.map((item, _idx) => (
            <InfoTimeCardAdv
              key={_idx}
              type="type3"
              title={item.title}
              value={item.value}
              prefix={item.prefix || ""}
              suffix={item.suffix || ""}
              variant="contained"
              color="primary"
            />
          )) || []}
        </InfoWrapper> */}
        <InfoWrapper className={"min-w-[250px]"}>
          {data?.cardsData?.map((item, _idx) => (
            <InfoCardNewAdv
              key={_idx}
              layout="option9"
              title={item?.title}
              titleConfig={{ className: "text-[16px]! leading-[20px]!" }}
              value={item?.value}
              prefix={item?.prefix || ""}
              suffix={item?.suffix || ""}
              onClick={() => {
                setKpiModalOpen(true);
                setKpiModalType(item?.title);
              }}
            />
          )) || []}
        </InfoWrapper>
        {/* </div> */}
      </div>

      <>
        {import.meta.env.VITE_APP_ENV === "local" && (
          <div className="flex-col items-center justify-start col-span-2 w-max-[50px] border border-primary p-2 rounded-lg">
            <div>Dev Note</div>
            <br />
            <div>Total AG1:{totalCounts.ag1}</div>
            <div>Total AG2:{totalCounts.ag2}</div>
          </div>
        )}
      </>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-[#FAFCFF] h-[340px] px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2">
          <ChartNew
            title="Aging Summary Report"
            expandIcon={false}
            type="tablechart"
            // expandedContent={renderAging1Content()}
            expandedContentPosition="top"
            rawData={addActions(data.invoices)}
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            chartLabel={"Candidate Name"}
            chartValue={"Past In Due"}
            chartToolbarRight={{
              chartToggle: true,
              expand: true,
            }}
            tableChartProps={{
              // if total prop is defined uncomment this line
              totalCount: totalCounts.ag1,
              hiddenFields: ["roleContacts"],
              hideToolBar: true,
              page: ag1Page,
              limit: ag1Limit,
              serverPagination: true,
              onPageChange: ag1SetPage,
              onLimitChange: ag1HandleLimitChange,
              hideToolBarInNormalView: true,
              hideToolBarInExpandedView: false,
            }}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[340px] px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2 lg:col-span-1">
          <ChartNew
            type="tablechart"
            title="Aging Summary Report"
            expandedContent={renderAging2Content()}
            expandedContentPosition="top"
            chartToolbarRight={{
              chartToggle: false,
              expand: true,
            }}
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            rawData={data.agingReport}
            chartLabel={"Client Name"}
            chartValue={"30-60"}
            tableChartProps={{
              // if total prop is defined uncomment this line
              totalCount: totalCounts.ag2,
              hideToolBar: true,
              page: ag2Page,
              limit: ag2Limit,
              serverPagination: true,
              onPageChange: ag2SetPage,
              onLimitChange: ag2HandleLimitChange,
              hideToolBarInNormalView: true,
              hideToolBarInExpandedView: false,
            }}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[340px] px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2 lg:col-span-1">
          <ChartNew
            title="Infographic Bar"
            expandedContent={renderInfoBarExpandContent()}
            expandedChartWidth="w-[70%]"
            expandedChartHeight="h-[450px]"
            type="barchart"
            barChartProps={{
              steps: 5,
              depth: 300,
              barWidth: "60px",
            }}
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            rawData={[
              {
                label: "Current",
                value: data?.infographicBar?.current || 0,
              },
              {
                label: "1-30",
                value: data?.infographicBar?.upto30 || 0,
              },
              {
                label: "30-60",
                value: data?.infographicBar?.upto60 || 0,
              },
              {
                label: "60-90",
                value: data?.infographicBar?.upto90 || 0,
              },
              {
                label: "90+",
                value: data?.infographicBar?.over90 || 0,
              },
            ]}
            // formatYAxisTick={(val) => `$ ${val}`}
            formatYAxisTick={(val) => formatCurrency(val)}
            backgroundColor={"bg-[#FAFCFF]"}
            chartLabel={"label"}
            chartValue={"value"}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[420px] flex flex-col flex-1 px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2">
          <ChartNew
            type="areachart"
            title="Revenue Flow Analysis"
            expandedContent={renderRevenueExpandContent()}
            expandedChartWidth="w-[95%]"
            expandedChartHeight="h-[350px]"
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            barChartProps={{
              steps: 5,
              depth: 300,
            }}
            rawData={data.revenueFlow}
            width="w-full"
            height="h-full"
            chartLabel={"label"}
            chartValue={"value"}
            backgroundColor="bg-[#FAFCFF]"
            minPointGap={72}
            formatYAxisTick={(val) => formatCurrency(val)}
            steps={3}
            chartToolbarRight={{
              selectDropdown: true,
              selectDropdownOptions: DropdownOptions,
              selectDropdownValue: selectedOption,
              onSelectDropdownChange: handleRevenueSelectChange,
              chartToggle: true,
              expand: true,
              add: [
                {
                  component: (
                    <div className="flex gap-3">
                      <div className="flex justify-end items-end w-fit">
                        <div className="w-[100px]">
                          <FormFieldSet
                            noTitle
                            placeholder="Select Year"
                            type="select"
                            size="sm"
                            value={selectedYear}
                            onChange={async (value) => {
                              //fetch data based on year change
                              if (!value) return;
                              if (value === selectedYear) return;
                              const revenueFlow = await fetchRevenueFlow(
                                selectedOption,
                                value,
                              );
                              setData((prev) => ({ ...prev, revenueFlow }));

                              setSelectedYear(value);
                            }}
                            options={yearOptions}
                          />
                        </div>
                      </div>
                    </div>
                  ),
                },
              ],
            }}
            areaChartProps={{
              steps: 5,
              showValueLabel: true,
              depth: 400,
              renderToolTip: (data) => (
                <div className="flex flex-col gap-3 text-sm">
                  <span className="text-primary">{data?.label}</span>
                  <div className="bg-primary-50 text-gray-600 text-xs font-medium w-full flex justify-start p-2 rounded shadow-md">
                    Revenue :{" "}
                    <span className="text-primary pl-1">{data?.revenue}</span>
                  </div>
                  <div className="bg-primary-50 text-gray-600 text-xs font-medium w-full flex justify-start p-2 rounded shadow-md">
                    Invoices :{"  "}
                    <span className="text-primary pl-1 text-start">
                      {data?.invoices}
                    </span>
                  </div>
                </div>
              ),
            }}
          />
        </div>

        <Backdrop isOpen={isLoading} zIndex={60}>
          <LogoLoader />
        </Backdrop>
        <Modal
          isOpen={selectedInvoice}
          title={"Invoice Details"}
          onClose={() => setSelectedInvoice(null)}
          showCloseButton={true}
          closeOnOutsideClick={true}
          width="max-w-full"
          zIndex={56}
        >
          <InvoiceDetails
            invoice={selectedInvoice}
            onBack={() => setSelectedInvoice(null)}
            removeButtonForPreview={true}
          />
        </Modal>
        <Modal
          isOpen={revenueFlowModalOpen}
          title={"Invoice Details"}
          onClose={() => {
            setRevenueFlowModalOpen(null);
            setKpiModalType(null);
          }}
          showCloseButton={true}
          closeOnOutsideClick={true}
          width="max-w-full"
          zIndex={56}
        >
          <InvoiceKPICard
            onClose={() => {
              setRevenueFlowModalOpen(false);
              setKpiModalType(null);
            }}
            data={null}
            cardsDuration={{ year: selectedYear }}
            dataType={kpiModalType}
          />
        </Modal>
        <Modal
          isOpen={phoneModal}
          title={"Phone numbers"}
          onClose={() => {
            setPhoneModal(false);
            setModalData([]);
          }}
          closeOnOutsideClick={true}
          width="max-w-3xl"
          zIndex={1000}
        >
          {Array.isArray(modalData) && modalData.length > 0 ? (
            <div className="flex flex-col gap-4">
              {modalData.flatMap((contact, idx) => {
                const role = contact?.role?.trim() || "N/A";
                const name = contact?.name?.trim() || "N/A";
                const phones = Array.isArray(contact?.phone)
                  ? contact.phone
                  : [];

                return phones.length > 0 ? (
                  phones.map((phone, pIdx) => (
                    <div
                      key={`${idx}-${pIdx}`}
                      className="grid grid-cols-3 gap-4 items-center border-b border-gray-200 pb-2"
                    >
                      <span className="font-medium text-left">{role}</span>
                      <span className="text-sm text-gray-600 text-center">
                        {name}
                      </span>
                      <span
                        className={`text-sm text-linkblue text-right cursor-pointer`}
                        onClick={() => handleCall(phone?.code + phone?.number)}
                      >
                        {phone?.code + phone?.number || "N/A"}
                      </span>
                    </div>
                  ))
                ) : (
                  <div
                    key={`no-email-${idx}`}
                    className="grid grid-cols-3 gap-4 items-center border-b border-gray-200 pb-2"
                  >
                    <span className="font-medium text-center">{role}</span>
                    <span className="text-sm text-gray-600 text-center">
                      {name}
                    </span>
                    <span className="text-sm text-gray-400 text-center">
                      No Phone Number
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-6">
              <span className="font-medium text-gray-500">
                No contacts found
              </span>
            </div>
          )}
        </Modal>
        <Modal
          isOpen={emailModal}
          title={"Emails"}
          onClose={() => {
            setEmailModal(false);
            setModalData([]);
          }}
          closeOnOutsideClick={true}
          width="max-w-3xl"
          zIndex={1000}
        >
          {Array.isArray(modalData) && modalData.length > 0 ? (
            <div className="flex flex-col gap-4">
              {modalData.flatMap((contact, idx) => {
                const role = contact?.role?.trim() || "N/A";
                const name = contact?.name?.trim() || "N/A";
                const emails = Array.isArray(contact?.email)
                  ? contact.email
                  : [];

                return emails.length > 0 ? (
                  emails.map((email, pIdx) => (
                    <div
                      key={`${idx}-${pIdx}`}
                      className="grid grid-cols-3 gap-4 items-center border-b border-gray-200 pb-2"
                    >
                      <span className="font-medium text-left">{role}</span>
                      <span className="text-sm text-gray-600 text-center">
                        {name}
                      </span>
                      <span
                        className={`text-sm text-linkblue text-right ${
                          email
                            ? "cursor-pointer"
                            : "opacity-50 cursor-not-allowed"
                        }`}
                        onClick={() => email && window.open(`mailto:${email}`)}
                      >
                        {email || "N/A"}
                      </span>
                    </div>
                  ))
                ) : (
                  <div
                    key={`no-email-${idx}`}
                    className="grid grid-cols-3 gap-4 items-center border-b border-gray-200 pb-2"
                  >
                    <span className="font-medium text-center">{role}</span>
                    <span className="text-sm text-gray-600 text-center">
                      {name}
                    </span>
                    <span className="text-sm text-gray-400 text-center">
                      No Email
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-6">
              <span className="font-medium text-gray-500">
                No contacts found
              </span>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default InvoiceDashboard;
